// services/childcare/activities.js
import { api, uploadApi } from "./utils";

// Get activity logs
export const getActivityLogs = async (filters = {}) => {
  try {
    const response = await api.get("/childcare/activity-logs", {
      params: filters,
    });
    return response;
  } catch (error) {
    console.error("Error fetching activity logs:", error);
    throw error;
  }
};

// Get child activity logs
export const getChildActivityLogs = async (childId) => {
  try {
    const response = await api.get(`/childcare/activity-logs/child/${childId}`);
    return response;
  } catch (error) {
    console.error("Error fetching child activities:", error);
    throw error;
  }
};

// Get activity logs by date
export const getActivityLogsByDate = async (date) => {
  try {
    const response = await api.get(`/childcare/activity-logs/date/${date}`);
    return response;
  } catch (error) {
    console.error("Error fetching activities by date:", error);
    throw error;
  }
};

// Create activity log
export const createActivityLog = async (activityData) => {
  try {
    const response = await api.post("/childcare/activity-logs", activityData);
    return response;
  } catch (error) {
    console.error("Error creating activity log:", error);
    throw error;
  }
};

// Update activity log
export const updateActivityLog = async (id, activityData) => {
  try {
    const response = await api.put(
      `/childcare/activity-logs/${id}`,
      activityData,
    );
    return response;
  } catch (error) {
    console.error("Error updating activity log:", error);
    throw error;
  }
};

// Delete activity log
export const deleteActivityLog = async (id) => {
  try {
    const response = await api.delete(`/childcare/activity-logs/${id}`);
    return response;
  } catch (error) {
    console.error("Error deleting activity log:", error);
    throw error;
  }
};

// Add photos to activity
export const addActivityPhotos = async (id, photos) => {
  try {
    const formData = new FormData();
    photos.forEach((photo) => {
      formData.append("photos", photo);
    });
    const response = await uploadApi.post(
      `/childcare/activity-logs/${id}/photos`,
      formData,
    );
    return response;
  } catch (error) {
    console.error("Error adding activity photos:", error);
    throw error;
  }
};
